// SomeComponent.jsx
import { toast } from "react-toastify";
import { showConfirmDialog } from "./ShowConfirmDialog";

const SomeComponent = () => {
  const handleDelete = () => {
    showConfirmDialog({
      title: "Delete Item",
      message: "Are you sure you want to delete this item?",
      type: "warning",
      onConfirm: () => {
        toast.error("Item deleted!");
      },
    });
  };

  return (
    <div>
      <button
        onClick={handleDelete}
        className="bg-red-500 text-white px-4 py-2 rounded"
      >
        Delete
      </button>
    </div>
  );
};

export default SomeComponent;
